import React from 'react';
import ReactMarkdown from "react-markdown";
import rehypeRaw from 'rehype-raw';

type customTextMarkdownType = {
    children: string;
    components?: object;
    className?: any;
    style?: any;
}

const customTextMarkdown = (props: customTextMarkdownType) => {
    return (
        <span className={props.className} style={props.style}>
            <ReactMarkdown components={props.components} rehypePlugins={[rehypeRaw]}>{props.children}</ReactMarkdown>
        </span>
    );
}

export default customTextMarkdown;